import React, { memo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { rem } from 'polished';
import styled from 'styled-components';

import { htmlElements } from 'helpers/translations';
import GenericButton from 'components/GenericButton/GenericButton';
import BasicModal from 'components/GenericModal/BasicModal';
import { GenericTitle } from 'components/GenericTitle/GenericTitle';
import GenericTitleSummary from 'components/GenericTitleSummary/GenericTitleSummary';
import IconSummary from 'components/Icons/IconSummary';
import type { Toggle } from 'components/VideoChat/types';

import VideoChatToolbarButton from '../VideoChatToolbarButton/VideoChatToolbarButton';

const TextButton = styled.div`
  color: ${({ theme }) => theme.colors.textDark};
  cursor: pointer;
`;

interface Props {
  toggle: Toggle;
  enabled: boolean;
}
export function TranscriptionButton({ toggle, enabled }: Props) {
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirm = () => {
    setOpen(false);
    toggle();
  };

  return (
    <>
      <VideoChatToolbarButton
        onClick={enabled ? toggle : handleOpen}
        icon={IconSummary}
        data-test="cmr-meeting-summary"
        aria-pressed={!enabled}
        tooltipText={
          enabled ? (
            <FormattedMessage id="video.tooltips.disableSummary" />
          ) : (
            <FormattedMessage id="video.tooltips.enableSummary" />
          )
        }
      />

      <BasicModal
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        width={rem(590)}
        shouldCloseOnOverlayClick={false}
      >
        <BasicModal.Title>
          <GenericTitle>
            <FormattedMessage id="video.summary.confirmTitle" />
          </GenericTitle>

          <GenericTitleSummary hasMarginTopSm>
            <FormattedMessage
              id="video.summary.confirmDescription"
              values={{ ...htmlElements, br: <br /> }}
            />
          </GenericTitleSummary>
        </BasicModal.Title>

        <BasicModal.Footer>
          <BasicModal.ModalButtons>
            <TextButton role="button" onClick={handleClose}>
              <FormattedMessage id="shared.cancel" />
            </TextButton>

            <GenericButton onClick={handleConfirm} isHalfWidth>
              <FormattedMessage id="video.summary.confirmAction" />
            </GenericButton>
          </BasicModal.ModalButtons>
        </BasicModal.Footer>
      </BasicModal>
    </>
  );
}

export default memo(TranscriptionButton);
